import { Label } from "reactstrap";
import { FresherInterview, Href, MollyBoake, OfwrriorCompanys } from "../../../../Constant";
import { H5, H6, Image, LI, P, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const InterviewHoveringTimeline = () => {
  return (
    <LI className="timeline-event">
      <Label className="timeline-event-icon"></Label>
      <div className="timeline-event-wrapper">
        <P className="timeline-thumbnail">{FresherInterview}</P>
        <H5>{OfwrriorCompanys}</H5>
        <span className="text-muted">A fresher's interview is to be conducted</span>
        <div className="pt-3 mb-0">
          <UL className="simple-list main-lists-content">
            <LI tag="a" className="list-group-item-action border-0 p-0 mb-4" href={Href}>
              <div className="d-flex w-100 justify-content-between align-items-center">
                <div className="list-wrapper">
                  <Image className="list-img" src={dynamicImage("user/1.jpg")} alt="profile" />
                  <div className="list-content">
                    <H6>{MollyBoake}</H6>
                    <P>MollyBoake@rhyta.com</P>
                  </div>
                </div>
                <div className="timeline-icon">
                  <i className="icon-facebook"></i>
                  <i className="icon-google"> </i>
                  <i className="icon-twitter-alt"></i>
                </div>
              </div>
              <P className="mb-1">Next step is to choose a tone of voice for your content type.</P>
            </LI>
          </UL>
        </div>
      </div>
    </LI>
  );
};
